import { render } from "./BasicEntities.vue?vue&type=template&id=686caa3a"
import script from "./BasicEntities.vue?vue&type=script&lang=js"
export * from "./BasicEntities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__